export default __webpack_public_path__ + "static/media/rocket-ship.50d41ec1fb82ce1e132d341256c97464.svg";